export default __webpack_public_path__ + "static/media/1904.55ad032a.png";